import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {List} from '@/components/core';
import Pager from '../_common/pager';
import Index from './_pages/index'
import Contact from './_pages/contact'
import News from './_pages/news'
import Join from './_pages/join'

const tabsMenusData = [
  { title: '企业简介', type: 'index' },
  { title: '联系我们', type: 'contact' },
  { title: '新闻动态', type: 'news' },
  { title: '加入我们', type: 'join' },
]

const PagesBody = props => {
  const hash = window.location.search.split('?')[1]
  const [type, setType] = React.useState(hash || 'index')
  const data = tabsMenusData.map(item => {
    return {
      title: <a href={'?'+item.type}>{item.title}</a>,
      itemClass: 'item' + (hash === item.type ? ' active': ''),
      onClick(e, param, inst) {
        inst.siblings().removeClass('active')
        inst.addClass('active')
        setType(item.type)
      }
    }
  })
  const tabsMenusCfg = {
    data: data,
    listClass: 'wid1200 pages-tab'
  }
  const currentContent = React.useMemo(()=>{
    switch (type) {
      case 'index':
        return <Index />
        break;
      case 'contact':
        return <Contact />
        break;
      case 'news':
        return <News />
        break;
      case 'join':
        return <Join />
        break;
    }
  }, [type])
  
  return (
    <div className="pages-container">
      <div className="pages-tab-wrap">
        <List {...tabsMenusCfg} />
      </div>
      {currentContent}
    </div>
  )
}
const cfg = {
  banner: {
    data: [
      {
        img: '/images/about/about.jpg',
        showButton: false,
        content: {
          title: '中国领先的产业AI应用服务商',
          desc: '链接产业生态，创造共信未来',
          buttonText: '关于明心',
          buttonType: 'modal',
          // className: 'color-fff'
        }
      }
    ]
  },
  body: <PagesBody />,
}
const App = () => {
  return <Pager {...cfg} />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)